import { render, staticRenderFns } from "./EachCountryTabContent.vue?vue&type=template&id=8a6c4c64&scoped=true&"
import script from "./EachCountryTabContent.vue?vue&type=script&lang=js&"
export * from "./EachCountryTabContent.vue?vue&type=script&lang=js&"
import style0 from "./EachCountryTabContent.vue?vue&type=style&index=0&id=8a6c4c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6c4c64",
  null
  
)

export default component.exports